import { DisplayEmailFormText } from 'features/authentication/types/types';
import { useAuthActions } from 'store/auth/use-auth-actions';
import { EmailDataFormParameters } from 'store/auth/actions/auth-actions/auth-action-types';
import { FORM_PLACEHOLDERS } from 'features/authentication/utils/constants';

export const displayText: DisplayEmailFormText = {
    title: 'Reset Your Password',
    subTitle: 'Enter your email below to receive password reset instructions',
    emailInputPlaceholders: FORM_PLACEHOLDERS.YOUR_EMAIL_PLACEHOLDER,
    buttonDisplayText: 'Send',
    returnLoginButton: 'Login',
    returnLoginDescription: 'Remember Password?',
};

export const useForgotPasswordForm = () => {
    const { sendForgotPasswordEmail } = useAuthActions();

    const sendEmail = async (data: EmailDataFormParameters) => {
        const statusPromise = await sendForgotPasswordEmail(data);
        return parseInt(statusPromise.toString());
    };
    return { sendEmail };
};
